import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const CustomPreset = definePreset(Aura, {
    primitive: {
        borderRadius: {
            none: '0',
            xs: '2px',
            sm: '4px',
            md: '6px',
            lg: '12px',
            xl: '16px',
        },
        // Custom cyan palette - vibrant
        wsn: {
            50: '#ecfeff',
            100: '#cffafe',
            200: '#a5f3fc',
            300: '#67e8f9',
            400: '#22d3ee',
            500: '#06b6d4',
            600: '#0891b2',
            700: '#0e7490',
            800: '#155e75',
            900: '#164e63',
            950: '#083344',
        },
    },
    semantic: {
        borderRadius: '{borderRadius.md}',
        // Map primary to custom palette
        primary: {
            50: '{wsn.50}',
            100: '{wsn.100}',
            200: '{wsn.200}',
            300: '{wsn.300}',
            400: '{wsn.400}',
            500: '{wsn.500}',
            600: '{wsn.600}',
            700: '{wsn.700}',
            800: '{wsn.800}',
            900: '{wsn.900}',
            950: '{wsn.950}',
        },
        content: {
            borderRadius: '{borderRadius.md}',
        },
        formField: {
            borderRadius: '{borderRadius.md}',
        },
        overlay: {
            modal: {
                borderRadius: '{borderRadius.md}',
            },
            popover: {
                borderRadius: '{borderRadius.md}',
            },
        },
        navigation: {
            item: {
                borderRadius: '{borderRadius.sm}',
            },
        },
    },
    components: {
        card: {
            root: {
                borderRadius: '{borderRadius.md}',
            },
            body: {
                padding: '1.75rem',
            },
        },
        tag: {
            root: {
                fontSize: '0.75rem',
                padding: '0.15rem 0.5rem',
            },
        },
    },
});
